module.exports = __webpack_public_path__ + "img/geiz.7ce1b120.png";